import styled from "styled-components";

import Header from "../Header404";
import { H3Tag, ParaTag, LandingButtonWhite } from "@tm/static";
import { Image } from "../Image";
import { theme } from "@tm/utility/global";

export const ErrorImg = styled.div`
  width: 230px;
  height: 230px;
  margin-bottom: 16px;
  align-self: center;
`;

export const ErrorPageStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  padding: 0 24px;
  box-sizing: border-box;
`;

export const ErrorPageContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 360px;
`;

export const ErrorPageActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin-top: 32px;
  gap: 12px;
`;

interface ErrorPageProps {
  errorImg?: string;
  title: string;
  info: string;
  errorEvent?: any;
  headerComponent?: JSX.Element;
  button1?: string;
  button2?: string;
  onButton1Click?: () => void;
  onButton2Click?: () => void;
}

export const ErrorPage = ({
  errorImg,
  title,
  info,
  errorEvent,
  headerComponent,
  button1,
  button2,
  onButton1Click,
  onButton2Click,
}: ErrorPageProps) => {
  return (
    <>
      {headerComponent || <Header />}
      <ErrorPageStyle>
        <ErrorPageContent>
          <ErrorImg>
            <Image src={errorImg} width="230" height="230" alt="Error" />
          </ErrorImg>
          <H3Tag color={theme.blackText}>{title}</H3Tag>
          <ParaTag
            textAlign="center"
            color={theme.greyText}
            fontSize="md"
            lineHeight="32px"
          >
            {info}
          </ParaTag>
          {(button1 || button2) && (
            <ErrorPageActions>
              {button1 && (
                <LandingButtonWhite
                  customTitle={button1}
                  customWidth="100%"
                  onClick={onButton1Click}
                />
              )}
              {button2 && (
                <LandingButtonWhite
                  customTitle={button2}
                  customWidth="100%"
                  onClick={onButton2Click}
                />
              )}
            </ErrorPageActions>
          )}
        </ErrorPageContent>
      </ErrorPageStyle>
    </>
  );
};
